import { render, staticRenderFns } from "./generalInfo.vue?vue&type=template&id=65f3ffe8&"
import script from "./generalInfo.js?vue&type=script&lang=js&"
export * from "./generalInfo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports